const messages = {
  heading: "Contact",
  name: "Name",
  email: "Email",
  message: "Message",
  submit: "Submit",
  clear: "Clear",
  placeholders: {
    name: "Your Name",
    email: "email@example.com",
    message: "Your message...",
  },
};

export default messages;
